var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sports-page" },
    [
      _c(
        "v-layout",
        { staticClass: "page-layout" },
        [
          _c(
            "v-flex",
            {
              ref: "maincolumn",
              staticClass: "main-column",
              style: { paddingTop: _vm.headerHeight + "px" }
            },
            [
              _c("resize-observer", { on: { notify: _vm.mainColumnResize } }),
              _vm._v(" "),
              _c("v-layout", { staticClass: "page-layout" }, [
                _c(
                  "div",
                  {
                    staticClass: "contests-wrapper",
                    class: { "padding-b-30": !_vm.isLoggedIn }
                  },
                  [
                    _vm.isContestsRootPage && _vm.isLoggedIn
                      ? _c(
                          "div",
                          [
                            _c("contests-carousel", {
                              attrs: { stage: "upcoming" }
                            }),
                            _vm._v(" "),
                            _c("contests-carousel", {
                              attrs: { stage: "entered" }
                            }),
                            _vm._v(" "),
                            _c("contests-carousel", {
                              attrs: { stage: "completed" }
                            })
                          ],
                          1
                        )
                      : _vm.isContestsRootPage && !_vm.isLoggedIn
                      ? _c(
                          "div",
                          [
                            _c("contests-carousel", {
                              attrs: {
                                isLoggedIn: _vm.isLoggedIn,
                                stage: "upcoming"
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "contests-no-logged-in-msg" },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(
                                      "Contests.Root.Page.Not.LoggedIn.Msg"
                                    )
                                  )
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c("img", {
                              staticClass: "contest-page-img",
                              attrs: {
                                src: require("@/assets/images/contests/alias_contest.jpg"),
                                alt: "contests-img"
                              }
                            })
                          ],
                          1
                        )
                      : _c(
                          "div",
                          { staticClass: "contests-page-wrapper" },
                          [_c("router-view")],
                          1
                        )
                  ]
                ),
                _vm._v(" "),
                !_vm.mobileBigAndBelow
                  ? _c(
                      "div",
                      {
                        staticClass: "contests-desktop-menu",
                        class: {
                          "bg-color":
                            _vm.isLoggedIn &&
                            !_vm.isContestsRootPage &&
                            !_vm.isRegistrationPage
                        }
                      },
                      [
                        !_vm.isContestsRootPage && !_vm.isRegistrationPage
                          ? [
                              _c("contest-picks-header"),
                              _vm._v(" "),
                              _c("contests-report-slider-menu", {
                                attrs: { isSlider: false }
                              })
                            ]
                          : [
                              _c("div", { staticClass: "trophy--img" }, [
                                _c("img", {
                                  attrs: {
                                    src: require("@/assets/images/contests/contest_trophy.png"),
                                    alt: "contests-img"
                                  }
                                })
                              ])
                            ]
                      ],
                      2
                    )
                  : _vm._e()
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("contests-error-dialog", {
        attrs: {
          errorMessage: _vm.errorDialogMessage,
          showErrorDialog: _vm.showErrorDialog
        },
        on: { "toggle-error-dialog": _vm.toggleErrorDialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2b3af3f3", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2b3af3f3","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/contests/ContestsPage.vue
// module id = null
// module chunks = 